import React, { useState, useEffect } from "react";
import {
  Button,
  Dropdown,
  Form,
  Nav,
  Navbar,
  NavDropdown,
  Offcanvas,
} from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import ReactFlagsSelect from "react-flags-select";
import Constants from "../Variables/Constants";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux"; // Import hooks
import { setCartItems } from "../../redux/cartSlice"; // Import the action
import engFlag from "./enflag.svg";
import frFlag from "./frflag.svg";
import iwFlag from "./iwflag.svg";
import yiFlag from "./yiflag.svg";
import esFlag from "./esFlag.svg";
import ruFlag from "./ruflag.svg";
import { toast } from "react-toastify";

function HeaderComponent() {
  const token = localStorage.getItem("token");
  const [getAllCategory, setCategory] = useState([]);
  const [select, setSelect] = useState("GB");
  const dispatch = useDispatch(); // Initialize dispatch
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleShow = () => setShowOffcanvas(true);
  const handleClose = () => setShowOffcanvas(false);

  const getData = async () => {
    try {
      axios.get(Constants.getUrls.getAllCategory).then((resp) => {
        if (resp.data.status == "success") {
          const data = resp.data.data.docs;
          if (data && Array.isArray(data) && data.length > 0) {
            setCategory(data);
          }
        }
      });
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  const cartItems = useSelector((state) => state.cardReducer.items);
  const cartLength = cartItems.length;

  const logout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  useEffect(() => {
    getData();
  }, []); // Only fetch on mount

  const googleTranslateElementInit = () => {
    new window.google.translate.TranslateElement(
      {
        pageLanguage: "en",
        autoDisplay: false,
        includedLanguages: "en,fr,yi,es,ru,iw",
      },
      "google_translate_element"
    );
  };

  useEffect(() => {
    var addScript = document.createElement("script");
    addScript.setAttribute(
      "src",
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
    );
    document.body.appendChild(addScript);
    window.googleTranslateElementInit = googleTranslateElementInit;
  }, []);

  // === Language Menu (desktop) ===
  const LANGUAGES = [
    { lang: "en", label: "English", flag: engFlag },
    { lang: "iw", label: "Hebrew", flag: iwFlag },
    { lang: "yi", label: "Yiddish", flag: yiFlag },
    { lang: "es", label: "Spanish", flag: esFlag },
    { lang: "ru", label: "Russian", flag: ruFlag },
    { lang: "fr", label: "France", flag: frFlag },
  ];

  function translateTo(lang) {
    // Google dropdown ko programmatically change karo
    const combo = document.querySelector("select.goog-te-combo");
    if (!combo) return;
    combo.value = lang;
    combo.dispatchEvent(new Event("change"));
  }

  function useCurrentLang() {
    const [current, setCurrent] = React.useState("en");
    useEffect(() => {
      // Jab user change kare to current state update karne ke liye observer
      const combo = document.querySelector("select.goog-te-combo");
      if (!combo) return;
      const onChange = () => setCurrent(combo.value || "en");
      combo.addEventListener("change", onChange);
      return () => combo.removeEventListener("change", onChange);
    }, []);
    return current;
  }

  function LanguageMenu() {
    const current = useCurrentLang();
    const active = LANGUAGES.find((l) => l.lang === current) || LANGUAGES[0];

    return (
      <Dropdown align="end" className="ms-2">
        <Dropdown.Toggle
          id="lang-menu"
          className="lang-toggle-btn d-flex align-items-center gap-2 border-0"
          variant="light"
        >

          <span className="lang-flag"><img loading="lazy"  src={active.flag} alt="" style={{ width: "20px" }} /></span>
          <span className="lang-label d-none d-xxl-inline">{active.label}</span>
        </Dropdown.Toggle>

        <Dropdown.Menu className="lang-dropdown-menu">
          {LANGUAGES.map((l) => (
            <Dropdown.Item
              key={l.lang}
              onClick={() => translateTo(l.lang)}
              active={l.lang === current}
              className="d-flex align-items-center gap-2"
            >
              <span className="lang-flag">
                <img loading="lazy"  src={l.flag} alt="" style={{ width: "20px" }} />
              </span>
              <span className="h4 m-0">{l.label}</span>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }


  return (
    <Navbar
      expand="xl"
      className="bestembroidery_navbar"
      style={{ backgroundColor: "var(--primary-color)" }}
    >
      {/* // return() ke bilkul start me ya Navbar ke just baad add karo: */}
      <div id="google_translate_element" style={{ position: "fixed", top: -9999, left: -9999 }} />

      <div className="container-fluid px-3 px-sm-4 px-lg-5 py-3 d-flex justify-content-between w-100 align-items-center">
        {/* Logo */}
        <NavLink to="/" className="navbar-brand">
          <img loading="lazy"  src={logo} className="w-75 e" alt="Logo" />
        </NavLink>

        {/* Navbar Toggle Button */}
        <div className="d-flex gap-1 d-xl-none ">
          <Navbar.Toggle
            onClick={handleShow}
            aria-controls="offcanvasNavbar-expand"
          ></Navbar.Toggle>
          {token ? (<>
            <NavLink
              onClick={handleClose}
              style={{ top: 6 }}
              className="nav-link fs-24 position-relative d-flex gap-1"
              to="carts"
            >
              <i className="bi bi-cart3"></i>
              <span className=" fw-normal">{cartLength}</span>
            </NavLink>
            <Dropdown>
              <Dropdown.Toggle
                variant="light"
                id="dropdown-basic"
                className="border-0 p-0  bg-transparent"
              >
                <div className="profile">
                  <img loading="lazy" 
                    src="/avatar.png"
                    alt="Profile"
                    className="rounded-circle me-1"
                  />
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu align="end">
                <Dropdown.Item className="fs-16" href="#">
                  <Link to="/profile" className=" text-dark">
                    Profile
                  </Link>
                </Dropdown.Item>
                <Dropdown.Item className="fs-16" href="#">
                  <Link to={"/settings"} className=" text-dark">
                    Settings
                  </Link>
                </Dropdown.Item>

                <div className="w-100 border-bottom pt-4  rounded-5"></div>
                <Dropdown.Item
                  href="#"
                  className="mt-4 d-flex pt-3 border pe-4"
                >
                  <Button
                    type="button"
                    className="rounded-5 logout fs-16 w-100 text-white fw-medium"
                    onClick={logout}
                  >
                    Logout
                  </Button>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </>) : (<>
            <NavLink
              onClick={handleClose}
              style={{ top: 2 }}
              className="nav-link fs-24 position-relative d-flex gap-1"
              to="carts"
            >
              <i className="bi bi-cart3"></i>
              <span className=" fw-normal">{cartLength}</span>
            </NavLink>
            <NavLink
              className="d-flex justify-content-center align-items-center w-100"
              to="login"
            >
              <Button className="rounded-5 logout fs-12 px-5 w-100 text-white fw-medium">
                Login
              </Button>
            </NavLink>
          </>
          )}
        </div>

        {/* Offcanvas Menu */}
        <Navbar.Offcanvas
          id="offcanvasNavbar-expand"
          show={showOffcanvas}
          onHide={handleClose}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              <NavLink onClick={handleClose} to="/" className="navbar-brand">
                <img loading="lazy"  src={logo} className="w-75" alt="Logo" />
              </NavLink>
            </Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body className=" d-none d-xl-flex justify-content-lg-between justify-content-center">
            {/* Navigation Links */}
            <Nav className="flex-grow-1 justify-content-center align-items-center pe-2 navBg">
              <NavLink onClick={handleClose} className="nav-link fs-16" to="/">
                Home
              </NavLink>

              <NavLink
                onClick={handleClose}
                className="nav-link fs-16"
                to="/about"
              >
                About
              </NavLink>

              <NavDropdown
                title="Products"
                className="nav-link fs-16"
                id="basic-nav-dropdown"
              >
                {getAllCategory.map((category, i) => (
                  <NavDropdown.Item key={category._id} className="text-muted fs-16" href={`/category?catid=${category._id}`}>
                    {category.title}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>

            </Nav>
            {/* <div id="google_translate_element" style={{ position: "absolute", left: -9999 }}></div> */}
            {/* <LanguageDropdown /> */}
            {/* Search Bar */}
            <Form className="nav_search_bar">
              <Form.Control
                type="search"
                className="border-0"
                placeholder="What are you looking for?"
              />
              <Button variant="px-2 pe-2 ">
                <i className="bi bi-search text-warning"></i>
              </Button>
            </Form>

            {/* Right Side Icons & Actions */}
            <Nav className="align-items-center gap-3">
              {/* Language menu (desktop) */}
              <div className="d-none d-xl-block">
                <LanguageMenu />
              </div>

              {/* Wishlist */}
              <NavLink
                onClick={handleClose}
                className="nav-link fs-20 mt-1"
                to="favorite"
              >
                <i className="bi bi-heart"></i>
              </NavLink>

              {/* Cart */}
              <NavLink
                onClick={handleClose}
                className="nav-link fs-20 position-relative d-flex gap-1"
                to="carts"
              >
                <i className="bi bi-cart3"></i>
                <span className=" fw-normal">{cartLength}</span>
              </NavLink>

              {token ? (
                <Dropdown>
                  <Dropdown.Toggle
                    variant="light"
                    id="dropdown-basic"
                    className="border-0 p-0  bg-transparent"
                  >
                    <div className="profile">
                      <img loading="lazy" 
                        src="/avatar.png"
                        alt="Profile"
                        className="rounded-circle me-1"
                      />
                    </div>
                  </Dropdown.Toggle>

                  <Dropdown.Menu align="end">
                    <Dropdown.Item className="fs-16" href="#">
                      <Link to="/profile" className=" text-dark">
                        Profile
                      </Link>
                    </Dropdown.Item>
                    <Dropdown.Item className="fs-16" href="#">
                      <Link to={"/settings"} className=" text-dark">
                        Settings
                      </Link>
                    </Dropdown.Item>

                    <div className="w-100 border-bottom pt-4  rounded-5"></div>
                    <Dropdown.Item
                      href="#"
                      className="mt-4 d-flex pt-3 border pe-4"
                    >
                      <Button
                        type="button"
                        className="rounded-5 logout fs-16 w-100 text-white fw-medium"
                        onClick={logout}
                      >
                        Logout
                      </Button>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                <NavLink className="fs-16 w-100" to="login">
                  <Button className="rounded-5 logout fs-16 w-100 text-white fw-medium">
                    Login
                  </Button>
                </NavLink>
              )}
            </Nav>
          </Offcanvas.Body>

          {/* ////////////////////////////////////////////////////////////////// */}

          <Offcanvas.Body className="d-flex flex-column align-items-center justify-content-between d-block d-xl-none">
            {/* Navigation Links */}
            <Nav className=" justify-content-center  align-items-center pe-2 navBg">
              <NavLink onClick={handleClose} className="nav-link fs-16" to="/">
                Home
              </NavLink>

              <NavDropdown
                title="Products"
                className="nav-link text-center fs-16"
                id="basic-nav-dropdown"
              >
                {getAllCategory.map((category, i) => (
                  <NavDropdown.Item key={i + 1} href={`/category?catid=${category._id}`} className="text-muted fs-16">
                    {category.title}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
              {/*  */}
              <NavLink
                onClick={handleClose}
                className="nav-link fs-16"
                to="/about"
              >
                About
              </NavLink>

              {/* Search Bar */}
              <Form className="nav_search_bar border mt-4">
                <Form.Control
                  type="search"
                  className="border-0"
                  placeholder="What are you looking for?"
                />
                <Button variant="outline-success px-2 pe-2">
                  <i className="bi bi-search text-warning"></i>
                </Button>
              </Form>

              <NavLink
                onClick={handleClose}
                className="nav-link fs-20 mt-1 mt-4"
                to="favorite"
              >
                <i className="bi bi-heart"></i>
              </NavLink>

              {/* Right Side Icons & Actions */}
              <Nav className="align-items-center gap-3">
                {/* Cart */}
                <NavLink
                  onClick={handleClose}
                  className=" text-muted  mt-2 fs-20 position-relative"
                  to="carts"
                >
                  <i className="bi bi-cart3"></i>
                  <span className="cart-badge">{cartLength}</span>
                </NavLink>
                {/* Language Selector */}
                <LanguageMenu />
              </Nav>

              {/* User Login / Logout */}
            </Nav>
            {token ? (
              <>
                {/* <span className="nav-link fs-20 fw-bold">{username}</span> */}
                <Button
                  variant="warning"
                  className="rounded-3 w-75 text-white  fw-medium"
                  onClick={logout}
                >
                  Logout
                </Button>
              </>
            ) : (
              <NavLink
                onClick={handleClose}
                className="nav-link fs-20 w-75"
                to="login"
              >
                <Button
                  variant="warning"
                  className="rounded-5 logout w-100 text-white fw-medium"
                >
                  Login
                </Button>
              </NavLink>
            )}
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </div>
    </Navbar>
  );
}

export default HeaderComponent;
